import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { StreetAccountFilterUI } from './ui';

export class StreetAccountFilter extends PureComponent {
    static displayName = 'StreetAccountFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'eventFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <StreetAccountFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const StreetAccountFilterContainer = compose()(StreetAccountFilter);
